import { useCallback, useReducer } from "react";

export interface SearchPhraseState {
  phrase: string;
  query: string;
}

export type SearchPhraseAction =
  | { type: "type"; value: string }
  | { type: "pick" }
  | { type: "reset" };

export const INITIAL_SEARCH_PHRASE: SearchPhraseState = {
  phrase: "",
  query: "",
};

export const searchPhraseReducer = (
  state: SearchPhraseState,
  action: SearchPhraseAction,
): SearchPhraseState => {
  switch (action.type) {
    case "type":
      return { phrase: action.value, query: action.value };
    case "pick":
      return state.phrase ? { ...state, phrase: "" } : state;
    case "reset":
      return state.phrase || state.query ? INITIAL_SEARCH_PHRASE : state;
  }
};

export const useSearchPhrase = () => {
  const [state, dispatch] = useReducer(
    searchPhraseReducer,
    INITIAL_SEARCH_PHRASE,
  );
  const onType = useCallback(
    (value: string) => dispatch({ type: "type", value }),
    [],
  );
  const onPick = useCallback(() => dispatch({ type: "pick" }), []);
  const reset = useCallback(() => dispatch({ type: "reset" }), []);

  return { ...state, onType, onPick, reset };
};
